import axios, {AxiosResponse} from 'axios';
import {AppConfig} from '@/app.config';
import {IBook} from "@/interfaces/book.interface";
import {AuthStore} from '@/modules/Auth/stores/auth.store';

class BookResources {
  getBook(params: any) {
    return (axios.post(AppConfig.apiUrl, {
      action: IBook.ACTION,
      params: params,
      token: AuthStore.state.token,
      version: 1.0
    }) as Promise<AxiosResponse>);
  }

  httpAction({ token, params }: { token: string, params: any }) {
    return (axios.post(AppConfig.apiUrl, {
      action: IBook.ACTION,
      params,
      token: token,
      version: 1.0
    }) as Promise<AxiosResponse>);
  }
}

export const bookResources = new BookResources();
